import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import PaymentSuccess from "./pages/PaymentSuccess";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import ChildSafety from "./pages/ChildSafety";
import ResetPasswordPage from "./pages/ResetPasswordPage";

import BidderProfilePopup from "./components/BidderProfilePopup";
import { Toaster } from "./components/ui/sonner";

import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <div
        className="App"
        style={{
          backgroundImage: "url('/Pridajte nadpis.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "100vh",
          width: "100%",
          overflowX: "hidden",
          overflowY: "auto",
        }}
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/child-safety" element={<ChildSafety />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
        </Routes>

        <BidderProfilePopup />

        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: "#0A0A0A",
              color: "#ffffff",
              border: "1px solid #FFD700",
            },
          }}
        />
      </div>
    </BrowserRouter>
  );
}

export default App;
